module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_library.js
// module id = 1094
// module chunks = 1